import { UserType } from 'types/user'
import { useEffect, useState } from 'react'
import { db } from 'firebase/index'

const useQueryLinkedUser = (id: string): UserType | undefined => {
  const [user, setUser] = useState<UserType | undefined>(undefined)
  useEffect(() => {
    if (!id) return
    db.collection('users')
      .doc(id)
      .get()
      .then((snapshot) => {
        const data = snapshot.data() as UserType
        setUser({ ...data })
      })
      .catch((error) => {
        console.error(error)
      })
  }, [id])
  return user
}

export default useQueryLinkedUser
